import { render, staticRenderFns } from "./MailVorlageStammdaten.vue?vue&type=template&id=6c03f9fc"
import script from "./MailVorlageStammdaten.vue?vue&type=script&lang=js"
export * from "./MailVorlageStammdaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports